import { PutMethod } from "../../methods/PutMethod";

export class SignChecklistEndpoint extends PutMethod<undefined> {
  constructor() {
    super(`${process.env.REACT_APP_MANAGEMENT_URL}/api/accept-checklist`);
  }
}
